import { RouteType } from "types/RouteType";
import ProjectBillingWizardStore from "./ProjectBillingWizardStore";

const ProjectBillingWizardRoute: RouteType = {
  name: "ProjectBillingWizard",
  path: "/workflows/project-billing",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Project Billing & Invoicing",
      component: () => import("./ProjectBillingWizardHeader"),
      enableRefreshButton: true,
      enableBackButton: false,
    },
    body: {
      component: () => import("./ProjectBillingWizard"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    if (!rootStore.projectBillingWizardStore) {
      rootStore.projectBillingWizardStore = new ProjectBillingWizardStore(
        rootStore
      );
    }
    await rootStore.projectBillingWizardStore.loadInitialData();
    return true;
  },
};

export default ProjectBillingWizardRoute;